export function getMapsCenter(address: { street: string; number: number; city: string }): string {
  const { street, number, city } = address;
  // Had to add ,Nederland at the end for edge cases, like Lover+187,Borne
  return street
    ? `${street.replace(/\s/g, '+')}+${number},${city.replace(/\s/g, '+')},Nederland`
    : 'Dam,Amsterdam';
}
